import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlackLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Name=Slack",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.78189 -0.000976562C7.45786 2.03017e-06 6.3863 1.0745 6.38728 2.39853C6.3863 3.72257 7.45884 4.79706 8.78287 4.79804H11.1785V2.39951C11.1794 1.07548 10.1069 0.000980623 8.78189 -0.000976562C8.78287 -0.000976562 8.78287 -0.000976562 8.78189 -0.000976562ZM8.78189 6.39902H2.3956C1.07156 6.4 -0.000975918 7.47449 2.67437e-06 8.79853C-0.00195451 10.1226 1.07058 11.1971 2.39462 11.199H8.78189C10.1059 11.198 11.1785 10.1235 11.1775 8.79951C11.1785 7.47449 10.1059 6.4 8.78189 6.39902Z",
				fill: "#36C5F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.9519 8.79951C23.9529 7.47547 22.8803 6.40097 21.5563 6.4C20.2323 6.40097 19.1597 7.47547 19.1607 8.79951V11.2H21.5563C22.8803 11.199 23.9529 10.1245 23.9519 8.79951ZM17.5646 8.79951V2.39951C17.5656 1.07645 16.494 0.00195719 15.17 0C13.846 0.000978593 12.7734 1.07547 12.7744 2.39951V8.79951C12.7725 10.1235 13.845 11.198 15.169 11.2C16.4931 11.199 17.5656 10.1245 17.5646 8.79951Z",
				fill: "#2EB67D"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.169 23.9998C16.4931 23.9988 17.5656 22.9243 17.5646 21.6003C17.5656 20.2763 16.4931 19.2018 15.169 19.2008H12.7734V21.6003C12.7725 22.9233 13.845 23.9978 15.169 23.9998ZM15.169 17.5988H21.5563C22.8803 17.5978 23.9529 16.5234 23.9519 15.1993C23.9539 13.8753 22.8813 12.8008 21.5573 12.7988H15.17C13.846 12.7998 12.7734 13.8743 12.7744 15.1983C12.7734 16.5234 13.845 17.5978 15.169 17.5988Z",
				fill: "#ECB22E"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.69125e-07 15.1993C-0.000977924 16.5233 1.07156 17.5978 2.3956 17.5988C3.71963 17.5978 4.79217 16.5233 4.79119 15.1993V12.7998H2.3956C1.07156 12.8008 -0.000977924 13.8753 6.69125e-07 15.1993ZM6.38727 15.1993V21.5993C6.38532 22.9233 7.45786 23.9978 8.78189 23.9998C10.1059 23.9988 11.1785 22.9243 11.1775 21.6003V15.2013C11.1794 13.8772 10.1069 12.8027 8.78287 12.8008C7.45785 12.8008 6.3863 13.8753 6.38727 15.1993Z",
				fill: "#E01E5A"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgSlackLogo);
export { ForwardRef as ReactComponent };
